import axios from 'axios'
import config from '../config'
import {
    Message
} from 'element-ui';
import {
    startLoading,
    endLoading
} from '../processing'
import {
    handleError
} from '../index'
import cookie from 'js-cookie'
import quit from '@/common/quit.js'
axios.defaults.baseURL = config.baseURL

function authHeader() {
    return {
        'x-auth-token': cookie.get('token')
    }
}

let base64 = ''
// const handleError = (error) => {
//     let response = error.response
//     if (response && (response.status == 401 || response.status == 403)) {
//         quit()
//     } else {
//         if (response && error.response.data) {
//             Message.error(error.response.data.message)
//         } else {
//             Message.error(error.toString())
//         }
//     }
// }

export default {
    getPatientTrainCalendar: async (patientId, data) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/training/clock`, {
                params: data,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientFinishedTrainDetail: async (patientId, trainingId) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/training/${trainingId}`, {
                // params: data,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientTrainList: async (patientId, courseId) => {
        startLoading();
        try {
            const params = {
                sort: 'courseNumber',
                size: 200
            }
            if (courseId) {
                params.courseId = courseId
            }
            const result = await axios.get(`/patient/${patientId}/training/`, {
                params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    setPatientTrainEyeConfig: async (data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/training/configuration`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    doctorEditPatient: async (data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    doctorUpdatePatientMedal: async (data, patientId) => {
        startLoading();
        try {
            const result = await axios.post(`/medal/${patientId}`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    doctorResetPatientPlan: async (courseId, patientId) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/${patientId}/course/${courseId}/reset`, {}, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getRemainingCourse: async (patientId, courseId) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/course/${courseId}/remaining`, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientCourseList: async (patientId) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/course`, {
                headers: authHeader()
            })
            endLoading()
            return result
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientCourseFormerLevel: async (courseId) => {
        startLoading();
        try {
            const result = await axios.get(`patient/course/${courseId}/formerLevel`, {
                headers: authHeader()
            })
            endLoading()
            return result
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientCaseRecords: async (patientId) => {
        startLoading();
        try {
            const params = {
                sort: 'createdAt,DESC',
            }
            const result = await axios.get(`/patient/${patientId}/case`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientCaseRecordDetial: async (patientCaseId) => {
        startLoading();
        try {
            const params = {
                patientCaseId,
            }
            const result = await axios.get(`/patient/case`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    saveCaseRecord: async (data, patientId) => {
        startLoading();
        try {
            const result = await axios.post(`/patient/${patientId}/case`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    saveEditCourse: async (data) => {
        startLoading();
        try {
            const result = await axios.post(`/patient/training/customize`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    doctorConfigPatientGameLevel: async (data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/training/game/level`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    doctorUpdatePatientAcount: async (type, data) => {
        startLoading();
        try {
            const patientId = data.patientId
            const params = {
                stationUUID: data.stationUUID,
                init: data.init
            }
            if (type === 'resetAccount') {
                const result = await axios.put(`/doctor/patient/${patientId}/reset`, null, {
                    params,
                    headers: authHeader()
                })
            } else if (type === 'stopAccount') {
                const result = await axios.put(`/doctor/patient/${patientId}/disable`, null, {
                    params,
                    headers: authHeader()
                })
            } else if (type === 'deleteAccount') {
                const result = await axios.delete(`/doctor/patient/${patientId}/delete`, {
                    params,
                    headers: authHeader()
                })
            }
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    doctorSetPatientGameReverse: async (data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/${data.patientId}/training/${data.trainingId}/reset`, null, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientRefundCount: async (patientId, stationId) => {
        startLoading();
        try {
            const params = {
                stationUUID: stationId,
            }
            const result = await axios.get(`/patient/${patientId}/treatment/refund/count`, {
                params,
                headers: authHeader(),
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    checkUserPhoneNumber: async (phoneNumber) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/phone/${phoneNumber}`, {
                headers: authHeader(),
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    transferPatient: async (data) => {
        startLoading();
        try {
            const result = await axios.post(`/patient/transfer/station`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientVisionChallenge: async (patientId, params) => {
        startLoading();
        try {
            const result = await axios.get(`/user/${patientId}/vision/challenge`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientSystemLog: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/log/game/running?sort=createdAt,DESC&sort=eventTime,DESC`, {
                headers: authHeader(),
                params,
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientAutolevel: async (patientId, courseId) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/course/${courseId}/autolevel`, {
                headers: authHeader(),
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updaetPatientAutolevel: async (patientId, courseId, data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/${patientId}/course/${courseId}/autolevel`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientGameAvgStatistic: async (gameId, params) => {
        startLoading();
        try {
            const result = await axios.get(`/game/${gameId}/training/month/statistic`, {
                headers: authHeader(),
                params
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    putGameIntroduce: async (data) => {
        startLoading();
        try {
            const result = await axios.put(`/game/principle`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getPatientNoteList: async (patientId, params) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/training/track/note`, {
                headers: authHeader(),
                params
            })
            endLoading()
            return result.data
        } catch (error) {
            console.log('????erroe', error)
            endLoading()
            handleError(error)
        }
    },
    getPatientTrainWeight: async (patientId) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/game/weight`, {
                headers: authHeader(),
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    setPatientTrainWeight: async (patientId, data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/${patientId}/game/weight`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getNextPatientTrainTrack: async (trackId, params) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/training/track/${trackId}/next?sort=trainingAt,DESC&sort=id`, {
                headers: authHeader(),
                params
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getXiaomuzhinengVisionCheck: async (patientId) => {
        startLoading();
        try {
            const result = await axios.get(`/patient/${patientId}/show/ai`, {
                headers: authHeader(),
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    setPatientTrainEnabled: async (patientId, data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/${patientId}/training/enabled`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    setPatientTrainValid: async (patientId, data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/${patientId}/valid`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updatePatientExpiredDate: async (data) => {
        startLoading();
        try {
            const result = await axios.put(`/patient/updatePatientExpiredDate`, data, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    removeCaseRecords: async (patientCaseId) => {
        startLoading();
        try {
            const result = await axios.delete(`/patient/case/${patientCaseId}`, {
                headers: authHeader(),
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getDoctorStationList: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/doctor/group/station`, {
                headers: authHeader(),
                params
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
}


// WEBPACK FOOTER //
// ./src/http/componentsAPI/doctor.js